export default {
    metaInfo() {
        return {
            title: this.$route.meta.title ?? null
        }
    },
}
